import { useGetAreasBlockinfoQuery } from 'features/documents/documents';
import { useMemo } from 'react';
import { createSelector } from '@reduxjs/toolkit';

export function useGetAreaBlockinfo(areaId, sectionId, documentId) {
    const findArea = useMemo(() => {
        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (res) => res.data,
            (_data, areaId) => areaId,
            (data, areaId) => {
                return data ? data.find((area) => area.id === areaId) : undefined;
            },
        );
    }, []);

    return useGetAreasBlockinfoQuery(
        { sectionId, documentId },
        {
            pollingInterval: 30000, // refresh every 30 seconds if window has focus
            skipPollingIfUnfocused: true,
            refetchOnFocus: true,
            selectFromResult: (result) => {
                return {
                    ...result,
                    blockinfo: findArea(result, areaId),
                };
            },
            skip: !areaId || !sectionId || !documentId,
        },
    );
}
